/* Fourth Dimension Club — interactions */
(function () {
  if (window.__fdcInit) return; window.__fdcInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Tesseract: a 4D hypercube rotating through the fourth dimension */
  function tesseract(canvas) {
    if (canvas.dataset.ready) return;
    canvas.dataset.ready = '1';
    var ctx = canvas.getContext('2d');
    var V = [];
    for (var i = 0; i < 16; i++) V.push([i & 1 ? 1 : -1, i & 2 ? 1 : -1, i & 4 ? 1 : -1, i & 8 ? 1 : -1]);
    var E = [];
    for (var a = 0; a < 16; a++) for (var b = a + 1; b < 16; b++) {
      var d = a ^ b; if ((d & (d - 1)) === 0) E.push([a, b]);
    }
    var lime = '214,255,61', violet = '142,107,255';
    var t = 0, w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
    var mx = 0, my = 0;
    function size() {
      var r = canvas.getBoundingClientRect(); w = r.width; h = r.height;
      canvas.width = w * dpr; canvas.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    size(); window.addEventListener('resize', size);
    canvas.parentElement.addEventListener('pointermove', function (e) {
      var r = canvas.getBoundingClientRect();
      mx = (e.clientX - r.left) / r.width - .5; my = (e.clientY - r.top) / r.height - .5;
    });
    function rot(p, i, j, ang) {
      var c = Math.cos(ang), s = Math.sin(ang), x = p[i], y = p[j];
      p[i] = x * c - y * s; p[j] = x * s + y * c;
    }
    var visible = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(canvas);
    function frame() {
      if (visible) {
        ctx.clearRect(0, 0, w, h);
        var P = V.map(function (v) {
          var p = v.slice();
          rot(p, 0, 3, t * .7);            // XW — the fourth-dimensional turn
          rot(p, 1, 3, t * .45);           // YW
          rot(p, 0, 2, t * .25 + mx * .8); // XZ
          rot(p, 1, 2, .35 + my * .8);     // YZ
          var k4 = 2.6 / (3.2 - p[3]);      // 4D -> 3D
          var x = p[0] * k4, y = p[1] * k4, z = p[2] * k4;
          var k3 = 3.4 / (5 - z);           // 3D -> 2D
          var s = Math.min(w, h) * .2;
          return { x: w / 2 + x * k3 * s, y: h / 2 + y * k3 * s, depth: p[3] };
        });
        ctx.lineWidth = 1.3;
        E.forEach(function (e) {
          var A = P[e[0]], B = P[e[1]], inner = (A.depth + B.depth) / 2;
          var al = .25 + (inner + 1) * .3;
          ctx.strokeStyle = 'rgba(' + (inner > 0 ? lime : violet) + ',' + al.toFixed(3) + ')';
          ctx.beginPath(); ctx.moveTo(A.x, A.y); ctx.lineTo(B.x, B.y); ctx.stroke();
        });
        P.forEach(function (p) {
          ctx.fillStyle = 'rgba(' + lime + ',' + (.5 + (p.depth + 1) * .25).toFixed(3) + ')';
          ctx.beginPath(); ctx.arc(p.x, p.y, 2.2 + (p.depth + 1), 0, 6.283); ctx.fill();
        });
        t += reduce ? 0 : .006;
      }
      if (!reduce) requestAnimationFrame(frame);
    }
    frame();
  }

  function reveal(root) {
    var els = root.querySelectorAll('.fdc-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e, i) { e.style.transitionDelay = (i % 4) * 70 + 'ms'; io.observe(e); });
  }

  function rails(root) {
    root.querySelectorAll('[data-fdc-rail]').forEach(function (wrap) {
      if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
      var rail = wrap.querySelector('.fdc-rail');
      wrap.querySelectorAll('[data-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          rail.scrollBy({ left: rail.clientWidth * .8 * (+btn.dataset.dir), behavior: 'smooth' });
        });
      });
    });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('.fdc-tesseract').forEach(tesseract);
    reveal(root); rails(root);
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
